// extracted by mini-css-extract-plugin
export var footerTop = "footer-module--footer-top--1a4CK";
export var footerTop__heading = "footer-module--footer-top__heading--1qbFv";
export var footerTop__subHeading = "footer-module--footer-top__sub-heading--2UtF0";
export var footerTop__contact = "footer-module--footer-top__contact--bGMwg";
export var footerBot = "footer-module--footer-bot--345AG";
export var footerBot__inner = "footer-module--footer-bot__inner--31KbS";
export var footerBot__col = "footer-module--footer-bot__col--pYYYD";